import React from 'react';
// import {domain} from "../App";
// import {notifyerror, notifysuccess} from "../Utility/Notification";

// const slugs = {
//     "ac":5,
//     "carpentery":12,
//     "electrician":10,
//     "fridge":6,
//     "microwave":8,
//     "plumbing":11,
//     "waterpurifier":7,
//     "washingmachine":9,
//     "tv":13,
// }

export default function () {
// const [data,setData] = useState([]);
// const categoryid = 12

    // const fetchblog = () => {
    //
    //
    //     let xhr = new XMLHttpRequest();
    //     xhr.open("POST", `https://blog.aturservices.co.in/wp-json/wp/v2/posts? categories=${slug}`);
    //     xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
    //
    //     xhr.send();
    //
    //     xhr.onload = () => {
    //         // console.log(xhr.response)
    //         const data = JSON.parse(xhr.response);
    //         if (data.error) {
    //             notifyerror(data.error);
    //         } else {
    //             notifysuccess("your request is successfully submitted");
    //             history.push("/")
    //             setData(data)
    //         }
    //     };
    // };
    return(
<h3>Blog section coming soon</h3>
)

}
